<template>
  <div class="date-picker-cpn">
    <div class="date-picker-select-area">
      <el-select size="mini"
                 v-if="showTsType"
                 v-model="timeType"
                 :disabled="disabled"
                 style="width: 130px; margin-right: 20px;"
                 @change="changeTsType">
        <el-option v-for="item in timeOptions"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value"
                   :disabled="item.disabled"></el-option>
      </el-select>
    </div>
    <div class="date-picker-picker-area">
      <MonthPickers v-if="timeType == 'month'"
                    ref="monthPickers"
                    :dateTime="dateTime"
                    :disabled="disabled"
                    :styleObj="{height:30,lineHeight:30}"
                    @change="dateChange"
                    @pickerPanelVisible="handlePickerPanelVisible" />
      <WeekPickers v-if="timeType == 'week'"
                   ref="weekPickers"
                   :dateTime="dateTime"
                   :disabled="disabled"
                   :styleObj="{height:30,lineHeight:30}"
                   @change="dateChange"
                   @pickerPanelVisible="handlePickerPanelVisible" />
      <DayPickers v-if="timeType == 'day'"
                  ref="dayPickers"
                  :dateTime="dateTime"
                  :disabled="disabled"
                  :styleObj="{height:30,lineHeight:30}"
                  @change="dateChange"
                  @pickerPanelVisible="handlePickerPanelVisible" />
    </div>
  </div>
</template>


<script>
import MonthPickers from './monthPickers/MonthPickers.vue'
import DayPickers from './dayPickers/DayPickers.vue'
import WeekPickers from './weekPickers/WeekPickers.vue'
export default {
  name: 'DatePickerComp',
  components: {
    MonthPickers,
    WeekPickers,
    DayPickers,
  },
  data() {
    return {
      timeType: 'month',
      timeOptions: [
        {
          label: '月度时间段',
          value: 'month',
        },
        {
          label: '周度时间段',
          value: 'week',
        },
        {
          label: '日度时间段',
          value: 'day',
        },
      ],
      startUnwatch: null,
      endUnwatch: null,
    }
  },
  props: {
    dateTime: {
      type: Array,
      default: () => [],
    },
    showTsRange: {
      type: Boolean,
      default: false,
    },
    pickerOptionsStart: {
      type: Object,
      default: () => null,
    },
    pickerOptionsEnd: {
      type: Object,
      default: () => null,
    },
    defaultTsType: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    popperClassConfig: {
      type: Object,
      default: () => ({
        enable: false,
        className: 'datePickerPopper',
        yearThreshold: 2023,
      }),
    },
  },
  provide() {
    return {
      pickerOptionsStart: this.pickerOptionsStart,
      pickerOptionsEnd: this.pickerOptionsEnd,
      disabled: this.disabled,
    }
  },
  computed: {
    showTsType() {
      return this.showTsRange
    },
  },
  methods: {
    changeTsType(val) {
      this.$emit('on-changeTsType', val)
    },
    dateChange(val) {
      this.$emit('on-changeDateTime', val)
    },
    getStartDatePicker() {
      // 获取当前激活的时间类型对应的picker组件
      const currentPicker = this.$refs[this.timeType + 'Pickers']
      if (currentPicker) {
        // 获取PickerPanel组件
        const pickerPanel = currentPicker.$refs.pickerPanel
        if (pickerPanel) {
          // 获取startDate的el-date-picker组件
          return pickerPanel.$refs.startDate
        }
      }
      return null
    },
    getEndDatePicker() {
      // 获取当前激活的时间类型对应的picker组件
      const currentPicker = this.$refs[this.timeType + 'Pickers']
      if (currentPicker) {
        // 获取PickerPanel组件
        const pickerPanel = currentPicker.$refs.pickerPanel
        if (pickerPanel) {
          // 获取endDate的el-date-picker组件
          return pickerPanel.$refs.endDate
        }
      }
      return null
    },
    formatDate(date, format) {
      if (!date) return ''
      const d = new Date(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return format
        .replace('{y}', year)
        .replace('{m}', month)
        .replace('{d}', day)
    },
    handlePickerPanelVisible(visible) {
      // 当PickerPanel显示时，执行setPopperClass方法
      if (visible && this.popperClassConfig && this.popperClassConfig.enable) {
        if (!this.startUnwatch && !this.endUnwatch) {
          this.setPopperClass()
        }
      } else {
        if (this.startUnwatch && typeof this.startUnwatch === 'function') {
          this.startUnwatch()
          this.startUnwatch = null
        }
        if (this.endUnwatch && typeof this.endUnwatch === 'function') {
          this.endUnwatch() // 调用取消观察函数
          this.endUnwatch = null // 清空引用
        }
      }
    },
    setPopperClass() {
      // 监听活动日历 年份发生变化后yearThreshold年以前的数据需要tip提示
      this.$nextTick(() => {
        const startPicker = this.getStartDatePicker() // 获取组件
        const endPicker = this.getEndDatePicker() // 获取组件
        if (!startPicker || !endPicker) return
        const start_picker = startPicker.picker
        const end_picker = endPicker.picker
        if (start_picker) {
          this.startUnwatch = start_picker.$watch('date', (newDate) => {
            let year = this.formatDate(newDate, '{y}')
            // 获取startDate的popper元素并添加/移除类名
            if (year < this.popperClassConfig.yearThreshold) {
              start_picker.popperClass = this.popperClassConfig.className
            } else {
              start_picker.popperClass = ''
            }
          })
        }
        if (end_picker) {
          this.endUnwatch = end_picker.$watch('date', (newDate) => {
            let year = this.formatDate(newDate, '{y}')
            if (year < this.popperClassConfig.yearThreshold) {
              end_picker.popperClass = this.popperClassConfig.className
            } else {
              end_picker.popperClass = ''
            }
          })
        }
      })
    },
  },
  created() {
    if (this.defaultTsType) {
      this.timeType = this.defaultTsType
    }
  },
  beforeDestroy() {
    // 确保监听器被清理
    if (this.startUnwatch && typeof this.startUnwatch === 'function') {
      this.startUnwatch()
    }
    if (this.endUnwatch && typeof this.endUnwatch === 'function') {
      this.endUnwatch()
    }
  },
  watch: {
    timeType(newVal, oldVal) {
      if (this.startUnwatch) {
        this.startUnwatch()
        this.startUnwatch = null
      }
      if (this.endUnwatch) {
        this.endUnwatch()
        this.endUnwatch = null
      }
      if (newVal !== oldVal) {
        this.$emit('on-changeTsType', newVal)
      }
    },
    defaultTsType() {
      this.timeType = this.defaultTsType
    },
  },
}
</script>
<style>
.month-picker-panel .main-area .start-month:hover,
.month-picker-panel .main-area .end-month:hover,
.week-picker-panel .main-area .start-month:hover,
.week-picker-panel .main-area .end-month:hover {
  z-index: 99999;
}
</style>
<style lang="less" scoped>
.date-picker-cpn {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
